import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Switch,
} from "antd";
import { isEmpty } from "lodash";
import { useMedicinesStore } from "./store";
import { optionsMedType } from "modules/utilities/utility";
import { useToast } from "modules/navbar/top/store/toasterStore";

function AddMedicineModal({ modalShow, setModalShow }) {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const {setToaster}=useToast();


  const { fetchMedicinesData, addMedicinesData} = useMedicinesStore();

  const handleModalClose = () => {
    form.resetFields();
    setModalShow(false);
  };

  const onSubmit = async (data) => {
    const trimmedData = {};
    for (const key in data) {
      trimmedData[key] =
        typeof data[key] === "string" ? data[key].trim() : data[key];
    }
    if (!isEmpty(trimmedData)) {
      trimmedData.tax_rate = parseFloat(trimmedData.tax_rate) / 100;
    }
    addMedicinesData(trimmedData, setToaster,fetchMedicinesData, handleModalClose);
  };

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add Community
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Form
            form={form}
            layout="vertical"
            name="add medicine"
            onFinish={onSubmit}
          >
            <Form.Item
              label="Medicine Name"
              name="medicine"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
                {
                  whitespace: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Dosage"
              name="dosage"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
                {
                  whitespace: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
                {
                  whitespace: true,
                  message: "Please fill this",
                },
              ]}
            >
              <TextArea autoSize />
            </Form.Item>

            <Form.Item
              label="Information"
              name="info"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
                {
                  whitespace: true,
                  message: "Please fill this",
                },
              ]}
            >
              <TextArea autoSize />
            </Form.Item>

            <Form.Item
              label="Select Medicine Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please fill this",
                },
              ]}
            >
              <Select allowClear options={optionsMedType} showSearch />
            </Form.Item>
            <Form.Item label="Combo Order" name="isCombo">
              <Switch
                checkedChildren="Yes"
                defaultChecked={false}
                unCheckedChildren="No"
              />
            </Form.Item>
            <Form.Item
              label="Tax Rate (in '%')"
              name="tax_rate"
              rules={[
                {
                  required: true,
                  message: "Please fill this field",
                },

                {
                  pattern: new RegExp(/^[0-9]/),
                  message: "Please enter valid Tax rate",
                },
              ]}
            >
              <InputNumber max={100} min={0} style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item style={{ textAlign: "center" }}>
              <Button type="primary" htmlType="submit">
                Add Medicine
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddMedicineModal;
